const COURSE_ROUTES = {
  COURSE_CREATE: {
    path: '/org/:orgName/course/create', base: '/create'
  },
  COURSE_HOME: {
    path: '/org/:orgName/course/user', base: '/user'
  },
  COURSE_UPDATE: {
    path: '/org/:orgName/course/update/:id', base: '/update/:id'
  },
  COURSE_UPLOAD: {
    path: '/org/:orgName/course/upload/:id', base: '/upload/:id'
  },
  COURSE_VIDEOS: {
    path: '/org/:orgName/course/videos/:id', base: '/videos/:id'
  },
  COURSE_ENROLLMENT_MANAGEMENT: {
    path: '/org/:orgName/course/enrollment-management/:courseId', base: '/enrollment-management/:courseId'
  },
  COURSE_ENROLLMENT_DETAILS: {
    path: '/org/:orgName/course/enrollment-management/:courseId/member/:userId', base: '/enrollment-management/:courseId/member/:userId'
  }
};

const TIMETABLE_ROUTES = {
  TIMETABLE_TEMPLATE_LISTING: {
    path: '/org/:orgName/timetable/template-listing', 
    base: '/template-listing'
  },
  TIMETABLE_CREATE_TEMPLATE: {
    path: '/org/:orgName/timetable/create-template', 
    base: '/create-template'
  },
  TIMETABLE_UPLOAD_EXCEL: {
    path: '/org/:orgName/timetable/upload-excel', 
    base: '/upload-excel'
  },
  TIMETABLE_EDIT_TEMPLATE: {
    path: '/org/:orgName/timetable/template-listing/:templateId/edit', 
    base: '/template-listing/:templateId/edit'
  },
  TIMETABLE_SLOT_MARK_ATTENDANCE: {
    path: '/org/:orgName/timetable/slot/:slotId/mark-attendance', 
    base: '/slot/:slotId/mark-attendance'
  },
  TIMETABLE_View_ATTENDANCE: {
    path: '/org/:orgName/timetable/attendance', 
    base: '/attendance'
  },
  TIMETABLE_USER: {
    path: '/org/:orgName/timetable/my', base: '/my'
  }
};

const GENERAL_ROUTES = {
  PAGE_NOT_FOUND: {
    path: '/page-not-found', base: '/page-not-found'
  }
};

const MEET_ROUTES = {
  MEET_HOME: {
    path: '/org/:orgName/meet', base: '/'
  },
  MEET_ROOM: {
    path: '/org/:orgName/meet/:code', base: '/:code'
  }
};

export const ROUTE_DEFINITIONS = {
  ...COURSE_ROUTES, ...GENERAL_ROUTES,
  ...TIMETABLE_ROUTES, ...MEET_ROUTES
};

export const ROUTES = Object.keys(ROUTE_DEFINITIONS).reduce((acc, key) => {
  acc[key] = key;

  return acc;
}, {});

export const resolveFullRoute = (routeKey, params = {}) => {
  const routeTemplate = ROUTE_DEFINITIONS[routeKey]?.path;

  if (!routeTemplate) {
    return ROUTE_DEFINITIONS.PAGE_NOT_FOUND.path;
  }

  const missingParams = [];
  const resolvedRoute = routeTemplate.replace(/:([a-zA-Z]+)/g, (match, key) => {
    if (params[key] !== undefined) {
      return params[key];
    }
    missingParams.push(key);

    return match;
  });

  if (missingParams.length > 0) {
    const errorMsg = `Missing required parameters: [${missingParams.join(
      ', '
    )}] for route "${routeKey}"`;

    if (process.env.NODE_ENV === 'development') {
      throw new Error(errorMsg);
    } else {
      return ROUTE_DEFINITIONS.PAGE_NOT_FOUND.path;
    }
  }

  return resolvedRoute;
};

export const resolveBaseRoute = (routeKey) => {
  return ROUTE_DEFINITIONS[routeKey]?.base || ROUTE_DEFINITIONS.PAGE_NOT_FOUND.base;
};
